/** Az EmailCategory backend enum számértékei. */
export enum EmailCategory {
  Other = 0,
  PasswordReset = 1,
  Welcome = 2,
  Invitation = 3,
  EventNotification = 4,
  AttendanceChange = 5,
  WeeklySummary = 6,
  SportDoctorReminder = 7,
  RegistrationDecision = 8,
  SchoolDocument = 9,
  FeeReminder = 10,
  PlayerApplication = 11,
}

export const EMAIL_CATEGORY_LABELS: Record<EmailCategory, string> = {
  [EmailCategory.Other]: 'Egyéb',
  [EmailCategory.PasswordReset]: 'Jelszó-visszaállítás',
  [EmailCategory.Welcome]: 'Üdvözlő levél',
  [EmailCategory.Invitation]: 'Meghívó',
  [EmailCategory.EventNotification]: 'Esemény értesítő',
  [EmailCategory.AttendanceChange]: 'Részvétel változás',
  [EmailCategory.WeeklySummary]: 'Heti összefoglaló',
  [EmailCategory.SportDoctorReminder]: 'Sportorvosi emlékeztető',
  [EmailCategory.RegistrationDecision]: 'Regisztráció elbírálása',
  [EmailCategory.SchoolDocument]: 'Iskolai dokumentum',
  [EmailCategory.FeeReminder]: 'Tagdíj emlékeztető',
  [EmailCategory.PlayerApplication]: 'Jelentkezés elbírálása',
};

export interface EmailLogEntry {
  id: number;
  toEmail: string;
  subject: string;
  category: EmailCategory;
  sentAt: string;
  isSuccess: boolean;
  error: string | null;
}

export interface EmailLogPage {
  items: EmailLogEntry[];
  /** Az aktuális szűrésre illeszkedő összes sor (lapozáshoz). */
  total: number;
  /** Az összes sikertelen küldés, szűréstől függetlenül. */
  failedTotal: number;
}
